import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Star, ExternalLink } from 'lucide-react';
import { ContactCTA } from '../components/ContactCTA';
export function ReviewsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const reviews = [{
    name: 'Michael T.',
    city: 'Harrison Township, MI',
    date: 'March 2024',
    text: 'Dominic and his team did an incredible job replacing our 20-year-old roof. They were communicative, clean, and finished the job in just two days. Highly recommend Moceri!'
  }, {
    name: 'Sarah J.',
    city: 'Macomb Township, MI',
    date: 'February 2024',
    text: 'We hired Moceri for new siding and gutters. The transformation is unbelievable. The crew was respectful of our property and the pricing was very fair compared to other quotes.'
  }, {
    name: 'David R.',
    city: 'Port Huron, MI',
    date: 'January 2024',
    text: 'After a major storm, we needed emergency roof repairs. Dominic came out the same day to tarp it and worked with our insurance to get the full replacement covered. True professionals.'
  }, {
    name: 'Jennifer L.',
    city: 'Clinton Township, MI',
    date: 'December 2023',
    text: 'Fantastic experience from start to finish. The new architectural shingles look beautiful and they left the yard spotless. Not a single nail found in the driveway.'
  }, {
    name: 'Robert M.',
    city: 'Sterling Heights, MI',
    date: 'November 2023',
    text: "Honest, reliable, and skilled. It's hard to find contractors you can trust these days, but Moceri Residential Services exceeded all expectations on our window replacement project."
  }, {
    name: 'Lisa K.',
    city: 'Marysville, MI',
    date: 'October 2023',
    text: 'We had our gutters replaced with seamless aluminum and added gutter guards. The quality of work is outstanding. No more climbing ladders to clean leaves every fall!'
  }, {
    name: 'Tom W.',
    city: 'Troy, MI',
    date: 'September 2023',
    text: 'Dominic gave us an honest assessment — told us we only needed a repair, not a full replacement. That kind of integrity is rare. We will absolutely call Moceri for any future work.'
  }, {
    name: 'Angela P.',
    city: 'Chesterfield, MI',
    date: 'August 2023',
    text: 'The exterior painting crew was meticulous. They prepped everything properly, used premium paint, and the house looks brand new. Neighbors keep asking who did the work!'
  }, {
    name: 'Chris D.',
    city: 'New Baltimore, MI',
    date: 'July 2023',
    text: 'Had our windows replaced throughout the entire house. The energy savings are already noticeable and the new windows look amazing. Professional crew from start to finish.'
  }, {
    name: 'Karen S.',
    city: 'Warren, MI',
    date: 'June 2023',
    text: 'Moceri handled our insurance claim after a hailstorm damaged our roof and siding. They made the entire process stress-free and the end result is better than the original.'
  }];
  return <div className="w-full bg-white" data-id="element-827">
      {/* Hero */}
      <section className="relative min-h-[35vh] flex items-center pt-20 pb-12 overflow-hidden bg-brand-gray-dark" data-id="element-828">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full relative z-10" data-id="element-829">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-830">
            <h1 className="font-heading font-black text-4xl md:text-5xl text-white mb-4" data-id="element-831">
              Customer{' '}
              <span className="text-brand-blue" data-id="element-832">Reviews & Testimonials</span>
            </h1>
            <p className="font-body text-xl text-gray-300 max-w-2xl" data-id="element-833">
              See what homeowners across Southeast Michigan are saying about
              Moceri Residential Services.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Rating Summary */}
      <section className="py-12 bg-gray-50 border-b border-gray-200" data-id="element-834">
        <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-835">
          <div className="flex justify-center text-yellow-400 mb-4" data-id="element-836">
            {[...Array(5)].map((_, i) => <Star key={i} size={40} fill="currentColor" data-id="element-837" />)}
          </div>
          <h2 className="font-heading font-bold text-4xl text-brand-gray-dark mb-2" data-id="element-838">
            5.0 Average Rating
          </h2>
          <p className="font-body text-brand-gray text-lg" data-id="element-839">
            Based on 50+ verified Google Reviews
          </p>
          <a href="#" className="inline-flex items-center gap-2 mt-4 text-brand-blue font-body font-semibold hover:text-brand-blue-dark transition-colors" data-id="element-840">
            Leave Us a Review on Google <ExternalLink size={16} data-id="element-841" />
          </a>
        </div>
      </section>

      {/* Reviews Grid */}
      <section className="py-20" data-id="element-842">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-843">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-844">
            {reviews.map((review, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index % 4 * 0.1
          }} className="bg-white p-8 rounded-xl shadow-sm border border-gray-100" data-id="element-845">
                <div className="flex text-yellow-400 mb-4" data-id="element-846">
                  {[...Array(5)].map((_, i) => <Star key={i} size={18} fill="currentColor" data-id="element-847" />)}
                </div>
                <p className="font-body text-brand-gray italic mb-6 leading-relaxed" data-id="element-848">
                  "{review.text}"
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-gray-50" data-id="element-849">
                  <div data-id="element-850">
                    <h3 className="font-heading font-bold text-brand-gray-dark" data-id="element-851">
                      {review.name}
                    </h3>
                    <p className="font-body text-xs text-brand-gray" data-id="element-852">
                      {review.city}
                    </p>
                  </div>
                  <span className="font-body text-xs text-brand-gray" data-id="element-853">
                    {review.date}
                  </span>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      <ContactCTA data-id="element-854" />
    </div>;
}